import { FaSearch } from "react-icons/fa"

export default function ProductSearch({
  searchTerm,
  setSearchTerm,
}) {
  return (
    <div className="relative w-full">
      <FaSearch
        className="
          absolute
          left-4
          top-1/2
          -translate-y-1/2
          text-gray-400
        "
      />

      <input
        type="text"
        value={searchTerm}
        onChange={(e) =>
          setSearchTerm(e.target.value)
        }
        placeholder="Rechercher un produit..."
        className="
          w-full
          pl-12
          pr-4
          py-4
          border
          border-gray-200
          rounded-xl
          focus:outline-none
          focus:ring-2
          focus:ring-blue-500
          focus:border-blue-500
        "
      />
    </div>
  )
}